module.exports = __webpack_public_path__ + "static/media/logo-bg-white.103ed710.svg";